import { cn } from '../../lib/cn';

/**
 * Les deux commandes d'une ligne de tâche, identiques dans toutes les vues :
 * le rond (à gauche) termine la tâche, la case carrée (à droite, au survol)
 * la sélectionne pour une action groupée.
 */
export function TaskDoneCircle({
  done,
  onToggle,
  disabled = false,
}: {
  done: boolean;
  onToggle: () => void;
  disabled?: boolean;
}) {
  const label = done ? 'Rouvrir la tâche' : 'Terminer la tâche';
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={done}
      aria-label={label}
      title={label}
      disabled={disabled}
      onClick={(e) => {
        e.stopPropagation();
        onToggle();
      }}
      className={cn(
        'grid h-[18px] w-[18px] flex-shrink-0 place-items-center rounded-full border-[1.5px] transition-colors',
        done
          ? 'border-[#2f7d5b] bg-[#2f7d5b] text-white'
          : 'border-neutral-300 bg-white text-transparent hover:border-[#2f7d5b] hover:text-[#2f7d5b]',
        disabled && 'cursor-default opacity-60',
      )}
    >
      <svg viewBox="0 0 12 12" className="h-2.5 w-2.5" aria-hidden>
        <path d="M2.2 6.2 4.8 8.8 9.8 3.2" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </button>
  );
}

export function TaskSelectBox({
  selected,
  selectionActive,
  onToggle,
}: {
  selected: boolean;
  /** Une sélection est en cours : les cases restent visibles sans survol. */
  selectionActive: boolean;
  onToggle: (shiftKey: boolean) => void;
}) {
  const label = selected ? 'Retirer de la sélection' : 'Sélectionner la tâche';
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={selected}
      aria-label={label}
      title={label}
      onClick={(e) => {
        e.stopPropagation();
        onToggle(e.shiftKey);
      }}
      className={cn(
        'grid h-4 w-4 flex-shrink-0 place-items-center rounded border transition',
        selected
          ? 'border-cime-primary bg-cime-primary text-white opacity-100'
          : cn(
              'border-neutral-300 bg-white text-transparent hover:border-cime-primary',
              selectionActive ? 'opacity-100' : 'opacity-0 focus-visible:opacity-100 group-hover:opacity-100',
            ),
      )}
    >
      <svg viewBox="0 0 12 12" className="h-2.5 w-2.5" aria-hidden>
        <path d="M2.2 6.2 4.8 8.8 9.8 3.2" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </button>
  );
}
